import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function SignIn({ user, setUser }) {
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  if (user) navigate("/");

  const handleEmailSignIn = async () => {
    await signInWithEmailAndPassword(auth, email, password)
      .then((result) => {
        setUser(result.user);
        if (result.user) navigate("/");
      })
      .catch((error) => setErrorMsg(error.message));
  };

  const handleEmailSignUp = async () => {
    await createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        setUser(result.user);
        if (result.user) navigate("/");
      })
      .catch((error) => setErrorMsg(error.message));
  };

  const handleForgotPassword = async () => {
    setErrorMsg(null);
    setSuccessMsg(null);
    if (!email) {
      setErrorMsg("Please enter your email to reset password.");
      return;
    }
    await sendPasswordResetEmail(auth, email)
      .then(() => {
        setSuccessMsg(
          "Password reset email sent. Please check your inbox. If you can't find it, check your spam folder"
        );
      })
      .catch((error) => setErrorMsg(error.message));
  };

  return (
    <div className="container flex items-center justify-center">
      <div className="grid items-center grid-cols-2 gap-3 w-2/4 min-w-72 justify-center">
        <h1 className="text-2xl col-span-2 w-full text-center">Sign In</h1>
        <div className="col-span-2 grid grid-cols-2 gap-3 w-full">
          <label className="col-span-2">
            Email
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="w-full border rounded p-2 mt-1"
            />
          </label>
          <label className="col-span-2">
            Password
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              className="w-full border rounded p-2 mt-1"
            />
          </label>
          {errorMsg && (
            <div className="text-red-600 col-span-2">{errorMsg}</div>
          )}
          {successMsg && (
            <div className="text-green-600 col-span-2">{successMsg}</div>
          )}
          <div className="col-span-2 text-blue-700">
            <button className="" onClick={handleForgotPassword}>
              Forgot Password?
            </button>
          </div>
          <button
            className="mt-2 px-4 py-2 w-full rounded bg-sky-600 text-white"
            onClick={handleEmailSignIn}
          >
            Sign In
          </button>
          <button
            className="mt-2 px-4 py-2 w-full rounded bg-sky-600 text-white"
            onClick={handleEmailSignUp}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}
